import { useIntl } from 'react-intl';
import { type UserFieldType } from '../../../../common/core-api';
import * as Styled from './Userfields.styled';

export const UserFields = ({ fields = [] }: { readonly fields?: UserFieldType[] }) => {
  const intl = useIntl();
  if (fields?.length === 0) {
    return null;
  }

  // Add a visually hidden heading for context
  return (
    <Styled.Wrapper>
      <Styled.ListHolder
        aria-label={intl.formatMessage({ id: 'userProfileFields', defaultMessage: 'User Profile Fields' })}
      >
        {fields?.map((field: UserFieldType) => (
          <Styled.FieldItem key={field.id}>
            <Styled.FieldTitle>{field.name}</Styled.FieldTitle>
            <Styled.FieldDescription>{field.value}</Styled.FieldDescription>
          </Styled.FieldItem>
        ))}
      </Styled.ListHolder>
    </Styled.Wrapper>
  );
};
